import styled from 'styled-components';

export const SoldOut = styled.div`
  background: ${({ theme }) => theme.colors.limoncello};
  color: ${({ theme }) => theme.old ? 'white' : theme.colors.charcoal};
  letter-spacing: 3px;
  font-size: 12px;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 30px;
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span {
    border: 1px solid black;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background: white;
    border-radius: 2px;
  }

  &:hover input ~ span {
    /* Hover Color */
    background-color: white;
  }

  input:checked ~ span {
    border: 1px solid #2a5caf;
    background-color: ${({ theme }) => theme.colors.limoncello};
  }

  span:after {
    content: '';
    position: absolute;
    display: none;
  }

  input:checked ~ span:after {
    display: block;
  }

  span:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid #2a5caf;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const FilterTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #4b4b4b;
`;

export const FilterButton = styled.div`
  cursor: pointer;
  margin: 5px;
  background: white;
  border: ${({ selected }) =>
    selected ? '2px solid #A83569' : '1px solid #dadada'};
  display: inline;
  padding: 10px;
  border-radius: 30px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;

  letter-spacing: 0.04em;

  color: #717171;
`;
